const pkConfig = {
  // 守护规则 - 林加汉
  guardRule: `/authApi/show/v1/guard/rules`,
  // 开通守护价格 - 林加汉
  openGuardPrice: `/authApi/show/v1/guard/openGuardPrice`,
  // 守护权限列表 - 林加汉
  privileges: `/authApi/show/v1/guard/privileges`,
  // 开通直播守护 - 刘阳
  activationGuard: `/liveApi/api/v2/Gift/activationGuard`,
  // 本房守护榜单 - 林加汉
  roomRank: `/authApi/show/v1/guard/roomRank`,
  // 人员本房守护榜单排名 - 林加汉
  personRoomRank: `/authApi/show/v1/guard/personRoomRank`,
  // 全站守护榜单 - 林加汉
  wholeStationRank: `/authApi/show/v1/guard/wholeStationRank`,
  // 当前主播守护排行 - 林加汉
  personStationRank: `/authApi/show/v1/guard/personStationRank`,
  // 守护榜单（巅峰榜）
  wholeTopRank: `/authApi/show/v1/guard/wholeTopRank`,
  // 当前主播守护巅峰排行
  personTopRank: `/authApi/show/v1/guard/personTopRank`
};

export default pkConfig;
